export enum TipoBloqueioAgenda {
    Pontual = 1,
    DiaInteiro = 2,
    Recorrente = 3,
    Periodo = 4
}

export interface BloqueioAgenda {
    id: number;
    tipo: TipoBloqueioAgenda;
    tipoDescricao: string;
    dataInicio: Date;
    dataFim: Date;
    diaSemanaRecorrente?: number;
    horaInicioRecorrente?: string;
    horaFimRecorrente?: string;
    motivo?: string;
    dataCriacao: Date;
}

export interface BloqueioAgendaListModel {
    id: number;
    tipo: TipoBloqueioAgenda;
    tipoDescricao: string;
    descricao: string;
    dataInicio: Date;
    dataFim: Date;
    motivo?: string;
    dataCriacao: Date;
}

export interface BloqueioAgendaPostModel {
    id: number;
    tipo: TipoBloqueioAgenda;
    dataInicio: string | Date;
    dataFim: string | Date;
    diaSemanaRecorrente?: number;
    horaInicioRecorrente?: string;
    horaFimRecorrente?: string;
    motivo?: string;
}
